import { render, staticRenderFns } from "./create-order.vue?vue&type=template&id=4d9f8afe&"
import script from "./create-order.vue?vue&type=script&lang=js&"
export * from "./create-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports